exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumb-section[data-v-1c7de8d9]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:10px}.breadcrumb-section .menu[data-v-1c7de8d9]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;margin:0;padding:0;color:#767676}.breadcrumb-section .menu .item[data-v-1c7de8d9],.breadcrumb-section .menu[data-v-1c7de8d9]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.breadcrumb-section .menu .item.with-icon[data-v-1c7de8d9]{margin-left:.2rem}svg[data-v-1c7de8d9]{height:20px;width:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c7de8d9","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/inventory/tag/components/breadcrumb.vue
// module id = V7ui
// module chunks = 113